import UserActions from '@Actions/userActions';
import { Menu } from 'antd';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LabelGenerationList from './LabelGenerationList';
import './style.scss';

const LabelGeneration = ({
  location, history, tab,
}) => {
  const [currentDocTab, setCurrentDocTab] = useState('');

  useEffect(() => {
    if (!(new URLSearchParams(location.search).get('docTab'))) {
      history.push(`?tab=${tab}&docTab=/grn`);
      setCurrentDocTab('/grn');
    } else if (new URLSearchParams(location.search).get('docTab')) {
      setCurrentDocTab(new URLSearchParams(location.search).get('docTab'));
    }
  }, []);

  const getItem = (label, key, icon, children, type) => ({
    label,
    key,
    icon,
    children,
    type,
  });

  const items = [
    getItem('Goods Receiving Note', '/grn'),
    getItem('Manufacturing Order', '/mo'),
    getItem('Invoice', '/inv'),
  ];

  const makeEntityName = (entityName) => entityName.replaceAll(' ', '_').toUpperCase();

  const getEntityName = (currentDoc) => {
    switch (currentDoc) {
    case '/grn':
      return makeEntityName('Good Receiving Note');

    case '/mo':
      return makeEntityName('Manufacturing Order');

    case '/inv':
      return makeEntityName('Invoice');

    default:
      return '';
    }
  };

  return (
    <Fragment>
      <div className="labels__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24">
            <div className="labels__inner__wrapper">
              <div className="labels__menu__wrapper">
                <Menu
                  className="labels__menu__items"
                  onClick={(event) => {
                    history.push(`?tab=${tab}&docTab=${event.key}`);
                    setCurrentDocTab(event.key);
                  }}
                  selectedKeys={[currentDocTab]}
                  defaultSelectedKeys={['1']}
                  mode="inline"
                  items={items}
                />
              </div>
              <div className="labels__table__wrapper">
                <div className="labels__table__data hide__in-mobile">
                  <LabelGenerationList
                    entityName={getEntityName(currentDocTab)}
                    tab={tab}
                    docTab={currentDocTab}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
});

LabelGeneration.propTypes = {
  user: PropTypes.object,
  location: PropTypes.func,
  history: PropTypes.any,
  tab: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LabelGeneration));
